/**
 * @file 事故発生状況ステータス変更
 *
 */
'use strict'

/**
 * @classname ChangeAccidentStatus
 * @classdesc 事故発生状況ステータス変更
 */
export default class ChangeAccidentStatus {
	/**
	 * @constructor
	 * @param {jQuery} $e - $('#accident_status')
	 */
	constructor($e) {
		console.log('ChangeAccidentStatus.constructor')
		this._$e = $e
		this._originalAccidentStatusName = this._$e.attr('name')
		this._$targets = $(this._$e.data('on-change-target'))
		this._$aftereffectStatus = $('#aftereffect_status')
		this._$aftereffectStatusTargets = $(this._$aftereffectStatus.data('on-change-target'))
		this._originalAftereffectStatusName = this._$aftereffectStatus.attr('name')
		this._$reminderDate = $('#reminder_date')
		this._$reminderRemarks = $('#reminder_remarks')
		this._originalReminderDateName = this._$reminderDate.attr('name')
		this._originalReminderRemarksName = this._$reminderRemarks.attr('name')
		this._$e.on('change', () => this.onChange())
		this._$aftereffectStatus.on('change', () => this.onAftereffectStatusChange())
		this._$reminderDate.on('change', () => this.onReminderDateChange())
		this._$reminderRemarks.on('change', () => this.onReminderRemarksChange())
		this.onChange()
		this.onAftereffectStatusChange()
		if(this._$reminderDate.prop('disabled')) this._$reminderDate.addClass('ignore-validate')
	}


	/**
	 * changeのコールバック
	 *
	 * @memberof ChangeAccidentStatus
	 * @return {undefined}
	 */
	onChange() {
		console.log(`ChangeAccidentStatus.onChange / ${$('#accident_status option:selected').data('accident-status')}`)
		if ($('#accident_status option:selected').data('accident-status') === 'aftereffect') {
			this._$targets.each((_, element) => {
				$(element).prop('disabled', false).find('.validate').removeClass('ignore-validate')
				this.enableBadge($(element).closest('.form-group').find('.badge'))
			})
			this._$aftereffectStatus.removeClass('ignore-validate')
			// 後遺障害の時はdisableにするが、accident_statusは送る
			this._$e.removeAttr('name')
			const val = this._$e.val()
			if(!$('#accident_status_hidden')[0]) this._$e.after(`<input type="hidden" id="accident_status_hidden" name="${this._originalAccidentStatusName}" value="${val}">`)
			// 後期障害の時は普通に戻す
			this._$aftereffectStatus.attr('name', this._originalAftereffectStatusName)
			$('#aftereffects_status_hidden').remove();
		} else {
			this._$targets.each((_, element) => {
				$(element).prop('disabled', true).find('.validate').addClass('ignore-validate')
				this.disableBadge($(element).closest('.form-group').find('.badge'))
			})
			this._$aftereffectStatus.removeClass('is-invalid').addClass('ignore-validate').closest('.form-group').find('.error-tip').removeClass('show').find('.error-tip-inner').html('')
			// 後遺障害以外の時はdisableをはずして、accident_status_hiddenを削除する
			this._$e.attr('name', this._originalAccidentStatusName)
			$('#accident_status_hidden').remove();
			// 後期障害以外の時でも#aftereffects_statusの値を送る
			this._$aftereffectStatus.removeAttr('name')
			const val = this._$aftereffectStatus.val()
			console.log(`val: ${val}`)
			if(!$('#aftereffects_status_hidden')[0]) this._$aftereffectStatus.after(`<input type="hidden" id="aftereffects_status_hidden" name="${this._originalAftereffectStatusName}" value="${val}">`)
		}
		this.onAftereffectStatusChange()
	}


	/**
	 * changeのコールバック
	 *
	 * @memberof ChangeAccidentStatus
	 * @return {undefined}
	 */
	onAftereffectStatusChange() {
		console.log(`ChangeAccidentStatus.onAftereffectStatusChange / ${$('#aftereffect_status option:selected').data('aftereffect-status')}`)
		switch($('#aftereffect_status option:selected').data('aftereffect-status')) {
			case 'unselected':
				this.enableAccidentStatus()
				this.disableReminderItems()
				this.resetReminderItems()
				break
			case 'wait-checking':
				this.disableAccidentStatus()
				this.enableReminderItems()
				break
			case 'payment-complete':
			case 'cancel':
				this.enableAccidentStatus()
				this.disableReminderItems()
				break
			default:
				this.disableAccidentStatus()
				this.disableReminderItems()
				break
		}
	}


	/**
	 * changeのコールバック
	 *
	 * @memberof ChangeAccidentStatus
	 * @return {undefined}
	 */
	onReminderDateChange() {
		console.log(`ChangeAccidentStatus.onReminderDateChange`)
		if($('#reminder_date_hidden')[0]) {
			const val = this._$reminderDate.val()
			$('#reminder_date_hidden').val(val)
		}
	}


	/**
	 * changeのコールバック
	 *
	 * @memberof ChangeAccidentStatus
	 * @return {undefined}
	 */
	onReminderRemarksChange() {
		console.log(`ChangeAccidentStatus.onReminderRemarksChange`)
		if($('#reminder_remarks_hidden')[0]) {
			const val = this._$reminderRemarks.val()
			$('#reminder_remarks_hidden').val(val)
		}
	}


	/**
	 * バッジのグレーアウト解除
	 *
	 * @memberof ChangeAccidentStatus
	 * @return {undefined}
	 */
	enableBadge($badge) {
		console.log(`ChangeAccidentStatus.enableBadge`)
		$badge.removeClass('badge-secondary')
		switch ($badge.text()) {
			case '必須':
				$badge.addClass('badge-danger')
				break
			case '任意':
				$badge.addClass('badge-success')
				break
			default:
				break
		}
	}


	/**
	 * バッジをグレーアウト
	 *
	 * @memberof ChangeAccidentStatus
	 * @return {undefined}
	 */
	disableBadge($badge) {
		console.log(`ChangeAccidentStatus.disableBadge`)
		$badge.removeClass('badge-danger badge-success').addClass('badge-secondary')
	}


	/**
	 * 処理状態を操作可にする
	 *
	 * @memberof ChangeAccidentStatus
	 * @return {undefined}
	 */
	enableAccidentStatus() {
		console.log(`ChangeAccidentStatus.enableAccidentStatus`)
		this._$e.prop('disabled', false)
		this.enableBadge(this._$e.closest('.form-group').find('.badge'))
	}


	/**
	 * 処理状態を操作不可にする
	 *
	 * @memberof ChangeAccidentStatus
	 * @return {undefined}
	 */
	disableAccidentStatus() {
		console.log(`ChangeAccidentStatus.disableAccidentStatus`)
		this._$e.prop('disabled', true)
		this.disableBadge(this._$e.closest('.form-group').find('.badge'))
	}


	/**
	 * リマインダー系を操作可にする
	 *
	 * @memberof ChangeAccidentStatus
	 * @return {undefined}
	 */
	enableReminderItems() {
		console.log(`ChangeAccidentStatus.enableReminderItems`)
		this._$aftereffectStatusTargets.each((_, element) => {
			$(element).prop('disabled', false).removeClass('ignore-validate').find('.validate').removeClass('ignore-validate')
			$(element).closest('.form-group').find('.input-group-text').removeClass('cursor-not-allowed').addClass('cursor-pointer').css('background-color', '#115740')
			this.enableBadge($(element).closest('.form-group').find('.badge'))
		})
	}


	/**
	 * リマインダー系を操作不可にする
	 *
	 * @memberof ChangeAccidentStatus
	 * @return {undefined}
	 */
	disableReminderItems() {
		console.log(`ChangeAccidentStatus.disableReminderItems`)
		this._$aftereffectStatusTargets.each((_, element) => {
			$(element).prop('disabled', true).addClass('ignore-validate').removeClass('is-invalid').find('.validate').addClass('ignore-validate').removeClass('is-invalid')
			$(element).closest('.form-group').find('.error-tip').removeClass('show').find('.error-tip-inner').html('')
			$(element).closest('.form-group').find('.input-group-text').removeClass('cursor-pointer').addClass('cursor-not-allowed').css('background-color', '#ebedef')
			this.disableBadge($(element).closest('.form-group').find('.badge'))
		})
		// disabledでも値を送る
		const $reminderDate = $('#reminder_date');
		const reminderDate = $reminderDate.val()
		$reminderDate.removeAttr('name')
		if(!$('#reminder_date_hidden')[0]) $reminderDate.after(`<input type="hidden" id="reminder_date_hidden" name="${this._originalReminderDateName}" value="${reminderDate}">`)
		const $reminderRemarks = $('#reminder_remarks');
		const reminderRemarks = $reminderRemarks.val()
		$reminderRemarks.removeAttr('name')
		if(!$('#reminder_remarks_hidden')[0]) $reminderRemarks.after(`<input type="hidden" id="reminder_remarks_hidden" name="${this._originalReminderRemarksName}" value="${reminderRemarks}">`)
	}


	/**
	 * リマインダー系をリセットする
	 *
	 * @memberof ChangeAccidentStatus
	 * @return {undefined}
	 */
	resetReminderItems() {
		console.log(`ChangeAccidentStatus.resetReminderItems`)
		this._$aftereffectStatusTargets.each((_, element) => $(element).val(''))
		// disabledでも値を送るものをリセット
		const $reminderDate = $('#reminder_date');
		$reminderDate.attr('name', this._originalReminderDateName)
		$('#reminder_date_hidden').remove()
		const $reminderRemarks = $('#reminder_remarks');
		$reminderRemarks.attr('name', this._originalReminderRemarksName)
		$('#reminder_remarks_hidden').remove()

	}
}
